/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { MatriculadoRegistro } from './../_models/matriculado';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatriculadoService } from '../_services/matriculado.service';
import { Router } from '@angular/router';
import jwt_decode  from 'jwt-decode';

@Component({
  selector: 'app-datos',
  templateUrl: './datos.component.html',
  styleUrls: ['./datos.component.css']
})
export class DatosComponent implements OnInit {

  matriculado: MatriculadoRegistro;
  loading: boolean;
  showData: boolean;
  showChangePassword: boolean = false;
  curr_user: string = '';
  onCancelPassword = new EventEmitter<boolean>();

  constructor(private service: MatriculadoService,
              private router: Router) {
      this.matriculado = new MatriculadoRegistro();
      this.loading = false;
      this.showData = false;
      let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
      if(currentUser != undefined) {
        let kermetPayload: {} = jwt_decode<any>(currentUser.token)['kermetPayload'];
        this.curr_user = kermetPayload['usuario'];
      }
   }

  ngOnInit() {
    const matriculado = sessionStorage.getItem('matriculado');
    if ( matriculado !== null) {
      this.showData = true;
      this.matriculado = JSON.parse(matriculado);
    }
    this.loading = true;
      this.service.getInfo().first().subscribe(
        datos => {
            this.matriculado = datos.registros[0];
            sessionStorage.setItem('matriculado', JSON.stringify(this.matriculado));
            this.loading = false;
            this.showData = true;
      },
      error => {
        this.redirectLogin(error);
    });
  }

  change_password(){
    this.showChangePassword = true;
  }

  cancel_change_password(){
    this.onCancelPassword.emit(true);
    this.showChangePassword = false;
  }

  redirectLogin(error: any) {
    if (error.status === 401 ) {
        this.router.navigate(['/login']);
    }
    this.loading = false;
  }
  ir_a(tab)
  {
    this.router.navigate([tab]);
  }
}
